import './app.scss';
import links from './assets/main-links';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCloud } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as Youtube } from './images/youtube.svg';
import { ReactComponent as Soundcloud } from './images/soundcloud.svg';
import { ReactComponent as Instagram } from './images/instagram.svg';
import Header from './components/header';
import * as LINKS from './constants/links';

function App() {
  return (
    <div className="App">
      <section>
        <Container>
          <Header />
          <div className='socials'>
            <a target='_blank' href={LINKS.youtube}><Youtube /></a>
            <a target='_blank' href={LINKS.instagram}><Instagram /></a>
            <a target='_blank' href={LINKS.soundcloud}><Soundcloud /></a>
          </div>
          <div className='links'>
            {links.links.map((link, i) => {
              return (
                <a className='lilita-one-regular' target='_blank' rel="noreferrer" key={i} href={link.link}>{link.name}</a>
              )
            })}
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/R-FlQnLXzaY?si=-5BhWqL_SlVXC18X"
              title="A broken robot - satic buzz"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
            <iframe
              width="100%"
              height="300"
              title="Ambient loops - satic buzz"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A955412005&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            ></iframe>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default App;
